import { Flex, FlexProps, Text, TextProps } from "@chakra-ui/react";
import React from "react";

function LabelText({
  label,
  text,
  separator = ":",
  labelProps,
  textProps,
  ...props
}: {
  label: string;
  text?: string | number | React.ReactNode;
  labelProps?: TextProps; 
  textProps?: TextProps;
  separator?: string | React.ReactNode;
} & FlexProps) {
  return (
    <Flex
      fontWeight="bold"
      color="surface.700"
      w="full"
      gap="1rem"
      sx={{
        textTransform: "capitalize",
        ...props?.sx,
      }}
      {...props}
    >
      <Text {...labelProps}>
        {label}
        {separator && (
          <Text as="span" ml="0.2rem">
            <>{separator}</>
          </Text>
        )}
      </Text>

      <Text wordBreak="break-all" {...textProps}>
        <>{text}</>
      </Text>
    </Flex>
  );
}

export default LabelText;
